export default {"src":"/_next/static/media/card-check.f4cdaa52.svg","height":26,"width":26};